import { Menu } from 'lucide-react';
import { Button } from 'src/components/ui/button';
import { NAV_ITEMS } from './AdminSidebar';
import Logo from './Logo';

export default function AdminNavbar({ onMenuClick, title }) {
  return (
    <header className="sticky top-0 z-30 flex h-16 items-center gap-3 border-b bg-background/90 px-4 backdrop-blur">
      <Button
        type="button"
        variant="ghost"
        size="icon"
        className="lg:hidden"
        onClick={onMenuClick}
        aria-label="Ouvrir le menu"
      >
        <Menu className="h-5 w-5" />
      </Button>
      <Logo size="sm" className="lg:hidden" />
      <div className="min-w-0">
        <p className="truncate text-sm font-semibold">{title || 'Administration IZYA'}</p>
        <p className="hidden text-xs text-muted-foreground sm:block">
          {NAV_ITEMS.length} modules de gestion
        </p>
      </div>
    </header>
  );
}
